import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';

const useSearch = (
  fetch,
  fetchSearchConfig,
  find,
  category,
  code,
  readStatus,
  searchConfigStatus,
  search,
  isNew,
  filtersVisible = false,
  disableFiltersVisible = null,
) => {
  useEffect(() => {
    if (filtersVisible && disableFiltersVisible) {
      // Needed to force Narrow View to show datasets opposed to filters when moving from Full View to Narrow View.
      disableFiltersVisible(category, code, { filtersVisible: false });
    }

    if (!searchConfigStatus || searchConfigStatus === states.NONE) {
      fetchSearchConfig();
    }

    if (search?.searchStatus === states.NONE && searchConfigStatus === states.SUCCESS) {
      find(category, code, 1, null, false, null, null);
    }

    if (readStatus !== states.NONE || isNew || search) return;
    fetch(category, code, 1, 10, true);
  }, [searchConfigStatus]);
};

export default {
  useSearch,
};
